export default __webpack_public_path__ + "static/view-page-737bc9319cf88c67225553fdf3a81cdf.jpg";